import React, { useState } from "react";
import "./Navbar.css";



const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  return (
    
    <div className="Navbar">
      <span className="nav-logo">ALUplanner</span>
      <div className={`nav-items ${isOpen && "open"}`}>
        <a href="./Baneer">Home</a>
        <a href="./About">About</a>
        <a href="./CardSlider">Service</a>
  
      </div>
      <button className="login"><a href="https://login-kakaymi10.vercel.app" target="_blank">Log in/Sign Up</a></button>
      <div
        className={`nav-toggle ${isOpen && "open"}`}
        onClick={() => setIsOpen(!isOpen)}
      >
        <div className="bar"></div>
      </div>
    </div>
  );
};

export default Navbar;